<nav class="navbar navbar-expand-lg">
    <img src="assets/img/logo.png" width="60" height="50">
    <a class="navbar-brand" style="margin-left: 15px; color: white;" href=""></a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>
</nav>